import { XIcon } from '@phosphor-icons/react'
import React from 'react'

import { Icon } from '@/components/ui/icon'

import * as S from './chip.styled'
import { ChipProps } from './chip.types'

export const Chip = ({
  label,
  color = 'blue',
  size = 'extra-small',
  variant = 'light',
  readOnly = false,
  onRemove,
  ...rest
}: ChipProps) => {
  return (
    <S.Chip $readOnly={readOnly} color={color} size={size} variant={variant} {...rest}>
      <S.ChipLabel>{label}</S.ChipLabel>
      {!readOnly && onRemove && (
        <S.ChipRemove
          $color={color}
          type="button"
          onClick={(event) => {
            event.stopPropagation()
            onRemove()
          }}
        >
          <Icon icon={XIcon} size="1.4rem" />
        </S.ChipRemove>
      )}
    </S.Chip>
  )
}
